import axios from "axios";

// Get client notifications
export function getMyNotifications(duration) {
  return axios.get(
    `/client/renewSubscription/detailsAboutSelectedSubscription/${duration}`
  );
}
